export default {
  sort: 5,
  path: '/newDetails/:id',
  name: 'newDetails',
  component: () => import('@/views/newDetails.vue'),
}



// WEBPACK FOOTER //
// ./src/router/modules/newDetails.js